import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-export-page',
  templateUrl: './export-page.component.html',
  styleUrls: ['./export-page.component.css'],
})
export class ExportPageComponent implements OnInit {
  protected filterParams: string;

  constructor() {}

  ngOnInit() {}

  public setFilterParams(params) {
    this.filterParams = params;
  }
}



// WEBPACK FOOTER //
// ./src/app/export/export-page/export-page.component.ts